export function makeMaxCharactersValidator<T>(maxCharacters: number, errorMsg: T, getException?: () => boolean) {
  return (value: string) => {
    const isException = getException && getException();

    if (isException) {
      return undefined;
    }

    const validatingValue = value || '';

    if (validatingValue?.length > maxCharacters) {
      return errorMsg;
    }

    return undefined;
  };
}
